import { default as FNS, logIn } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAll } from './shownDataSlice';
import { toast } from 'react-toastify';




export const fetch = createAsyncThunk('knownArrangements/fetch', async ({ id }, { dispatch }) => {
  try {
      
    const res = await FNS.getArrangement(id);
    dispatch(knownArrangementsSlice.actions.addKnowns({ values: [res] }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const ensureKnown = createAsyncThunk('knownArrangements/ensureKnown', async ({ id }, { dispatch, getState }) => {
  try {
    const state = getState();

    if(id in state.knownArrangements.arrangements) return;
    
    const res = await FNS.getArrangement(id);
    dispatch(knownArrangementsSlice.actions.addKnowns({ values: [res] }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateArrangement = createAsyncThunk('knownArrangements/updateArrangement', async ({ id, name, description, driver, on_monday, on_tuesday, on_wednesday, on_thursday, on_friday, on_saturday, on_sunday, start, end, depart, duration }, { dispatch }) => {
  try {

    const res = await FNS.updateArrangement(id, name, description, driver, on_monday, on_tuesday, on_wednesday, on_thursday, on_friday, on_saturday, on_sunday, start, end, depart, duration);
    await dispatch(fetch({ id }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const createArrangement = createAsyncThunk('knownArrangements/createArrangement', async ({ id, name, description, driver, on_monday, on_tuesday, on_wednesday, on_thursday, on_friday, on_saturday, on_sunday, start, end, depart, duration }, { dispatch }) => {
  try {

    const res = await FNS.createArrangement(name, description, driver, on_monday, on_tuesday, on_wednesday, on_thursday, on_friday, on_saturday, on_sunday, start, end, depart, duration);
    await dispatch(fetch({ id: res.id }));
    return res.id;

  } catch (e) {
    toast.error(e.message);
  }
});

export const deleteArrangement = createAsyncThunk('knownArrangements/deleteArrangement', async ({ id }, { dispatch }) => {
  try {

    const res = await FNS.deleteArrangement(id);
    await dispatch(fetchAll());
    return id;

  } catch (e) {
    toast.error(e.message);
  }
});

export const fetchArrangementsExceptions = createAsyncThunk('knownArrangements/fetchArrangementExceptions', async ({ id }, { dispatch }) => {
  try {
      
    const res = await FNS.getArrangementsExceptions(id);
    dispatch(knownArrangementsSlice.actions.addKnownExceptions({ values: res }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const fetchArrangementExceptions = createAsyncThunk('knownArrangements/fetchArrangementException', async (payload, { dispatch }) => {
  try {
      
    const res = await FNS.getArrangementExceptions();
    console.log("db21: res:", res);
    dispatch(knownArrangementsSlice.actions.replaceKnownExceptions({ values: res }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const ensureArrangementExceptionKnown = createAsyncThunk('knownArrangements/ensureArrangementExceptionKnown', async ({ id }, { dispatch, getState }) => {
  try {
    const state = getState();

    if(id in state.knownArrangements.exceptions) return;
    
    const res = await FNS.getArrangement(id);
    dispatch(knownArrangementsSlice.actions.addKnownExceptions({ values: [res] }));

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateArrangementException = createAsyncThunk('knownArrangements/updateArrangementException', async ({ id, description, driver, depart }, { dispatch }) => {
  try {

    const res = await FNS.updateArrangementException(id, depart, description, driver);
    await dispatch(fetchArrangementsExceptions({ id }));
    return id;

  } catch (e) {
    toast.error(e.message);
  }
});

export const createArrangementException = createAsyncThunk('knownArrangements/createArrangementException', async ({ id, date, depart, description, driver }, { dispatch }) => {
  try {

    const res = await FNS.createArrangementException(id, date, depart, description, driver);
    await dispatch(fetchArrangementsExceptions({ id }));
    return id;

  } catch (e) {
    toast.error(e.message);
  }
});

export const deleteArrangementException = createAsyncThunk('knownArrangements/deleteArrangementException', async ({ id }, { dispatch }) => {
  try {

    const res = await FNS.deleteArrangementException(id);
    await dispatch(knownArrangementsSlice.actions.deleteKnownException({ id }));
    await dispatch(fetchArrangementsExceptions({ id }));
    return id;

  } catch (e) {
    toast.error(e.message);
  }
});



const knownArrangementsSlice = createSlice({
  name: 'knownArrangements',
  initialState: {
    arrangements: {},
    exceptions: {},
    exceptionsList: [],
  },
  reducers: {
    addKnowns: (state, { payload: { values } }) => {
      for(const arrangement of values) {
        state.arrangements[arrangement.arrangement_id] = arrangement;
      }
    },
    addKnownExceptions: (state, { payload: { values } }) => {
      for(const exception of values) {
        state.exceptions[exception.exception_id] = exception;
        state.exceptionsList.push(exception);
      }
    },
    replaceKnownExceptions: (state, { payload: { values } }) => {
      state.exceptions = {};
      state.exceptionsList = [];
      for(const exception of values) {
        state.exceptions[exception.exception_id] = exception;
        state.exceptionsList.push(exception);
      }
    },
    deleteKnownException: (state, { payload: { id } }) => {
      delete state.exceptions[id];
      state.exceptionsList = state.exceptionsList.filter(exception => exception.exception_id != id);
    },
  },
});

export const { addKnowns } = knownArrangementsSlice.actions;
export default knownArrangementsSlice.reducer;
